var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-plus"},on:{"click":_vm.createCertificate}},[_vm._v("新建证书")]),_c('certificate-modal',{ref:"modal",attrs:{"vendorId":_vm.userInfo.orgId,"fetch":_vm.fetchList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }